/**
 * Application Configuration
 */

export const APP_CONFIG = {
  // API version for Salesforce
  apiVersion: 'v59.0',

  // Storage keys
  storageKeys: {
    jwt: 'kleda_kantoor_jwt',
    user: 'kleda_kantoor_user',
  },
} as const;

export const GOOGLE_MAPS_CONFIG = {
  apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  defaultCenter: { lat: 52.7558, lng: 6.3969 }, // Havelte depot
  defaultZoom: 10,
} as const;
